/**
 * Chooses the API implementation: the real client-api through fetch/EventSource, or the in-browser mock backend
 * when VITE_USE_MOCKS=1. The mock code is dynamically imported so it never ships in the production entry.
 */
import type { ApiContextValue } from '../api/api_context';
import { createClientEndpoints } from '../api/client_endpoints';
import { ApiClient } from '../api/http_client';
import { fetchTransport } from '../api/http_transport';
import { browserEventSourceFactory } from '../api/live_stream';

export function mocksEnabled(): boolean {
  return import.meta.env.VITE_USE_MOCKS === '1';
}

export function createNetworkApi(): ApiContextValue {
  return {
    endpoints: createClientEndpoints(new ApiClient(fetchTransport)),
    createEventSource: browserEventSourceFactory,
  };
}

export async function createApiForEnvironment(): Promise<ApiContextValue> {
  if (!mocksEnabled()) {
    return createNetworkApi();
  }
  const { createMockApi } = await import('../mocks/mock_api');
  return createMockApi().api;
}
